import { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Menu, X, ArrowUpRight } from "lucide-react";
import { scrollToSection } from "@/App";

const LINKS = [
  { id: "courses", label: "01 / Courses", testid: "navbar-link-courses" },
  { id: "consulting", label: "02 / Consulting", testid: "navbar-link-consulting" },
  { id: "testimonials", label: "03 / Stories", testid: "navbar-link-testimonials" },
  { id: "blog", label: "04 / Blog", testid: "navbar-link-blog" },
  { id: "contact", label: "05 / Contact", testid: "navbar-link-contact" },
];

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const go = (id) => {
    setOpen(false);
    scrollToSection(id);
  };

  return (
    <motion.header
      initial={{ y: -80, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.9, ease: [0.22, 1, 0.36, 1], delay: 0.2 }}
      style={{ x: "-50%" }}
      className="fixed top-4 left-1/2 z-50 w-[92%] max-w-6xl"
      data-testid="navbar"
    >
      <div className="backdrop-blur-xl bg-[#ffffff]/80 border border-slate-200 rounded-full pl-6 pr-2 py-2 flex items-center justify-between shadow-2xl">
        <button onClick={() => scrollToSection("home")} className="flex flex-col items-start leading-none group" data-testid="navbar-brand-logo">
          <span className="font-display font-bold tracking-tight text-sm sm:text-base group-hover:text-amber-600 transition-colors duration-300">VIKRAM FOTANI</span>
          <span className="font-mono2 text-[9px] tracking-[0.3em] text-slate-500 uppercase">SAP S/4HANA Transformation Leader</span>
        </button>

        <nav className="hidden lg:flex items-center gap-6">
          {LINKS.map((l) => (
            <button
              key={l.id}
              data-testid={l.testid}
              onClick={() => go(l.id)}
              className="font-mono2 text-[11px] tracking-wider text-slate-600 hover:text-amber-600 transition-colors duration-300"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="flex items-center gap-2">
          <button
            data-testid="navbar-cta-advisory"
            onClick={() => go("book")}
            className="hidden sm:flex items-center gap-1.5 bg-amber-400 text-slate-900 font-semibold text-xs px-5 py-2.5 rounded-full hover:bg-amber-500 transition-colors duration-300"
          >
            Book Advisory <ArrowUpRight size={14} />
          </button>
          <button
            data-testid="navbar-mobile-menu-button"
            onClick={() => setOpen(!open)}
            className="lg:hidden p-2.5 rounded-full border border-slate-200 text-slate-700"
            aria-label="Toggle menu"
          >
            {open ? <X size={16} /> : <Menu size={16} />}
          </button>
        </div>
      </div>

      <AnimatePresence>
        {open && (
          <motion.div
            initial={{ opacity: 0, y: -8 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -8 }}
            transition={{ duration: 0.25 }}
            className="lg:hidden mt-2 rounded-3xl border border-slate-200 bg-[#F8FAFC]/95 backdrop-blur-xl p-4 flex flex-col gap-1"
            data-testid="navbar-mobile-drawer"
          >
            {LINKS.map((l) => (
              <button
                key={l.id}
                data-testid={`${l.testid}-mobile`}
                onClick={() => go(l.id)}
                className="text-left font-mono2 text-xs tracking-wider text-slate-700 hover:text-amber-600 py-3 px-3 rounded-xl hover:bg-slate-100 transition-colors"
              >
                {l.label}
              </button>
            ))}
            <button
              data-testid="navbar-cta-advisory-mobile"
              onClick={() => go("book")}
              className="mt-2 flex items-center justify-center gap-1.5 bg-amber-400 text-slate-900 font-semibold text-sm px-5 py-3 rounded-full"
            >
              Book Advisory <ArrowUpRight size={14} />
            </button>
          </motion.div>
        )}
      </AnimatePresence>
    </motion.header>
  );
};

export default Navbar;
